export default __webpack_public_path__ + "static/media/otege_senayan.967adcda.png";